// source: mlmbox/client/confirmation/v1/confirmation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var mlmbox_type_confirmation_pb = require('../../../../mlmbox/type/confirmation_pb.js');
goog.object.extend(proto, mlmbox_type_confirmation_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest', null, global);
goog.exportSymbol('proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field', null, global);
goog.exportSymbol('proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.displayName = 'proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.repeatedFields_, null);
};
goog.inherits(proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.displayName = 'proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.displayName = 'proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    confirmation: (f = msg.getConfirmation()) && mlmbox_type_confirmation_pb.Confirmation.ID.toObject(includeInstance, f),
    fieldId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest;
  return proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new mlmbox_type_confirmation_pb.Confirmation.ID;
      reader.readMessage(value,mlmbox_type_confirmation_pb.Confirmation.ID.deserializeBinaryFromReader);
      msg.setConfirmation(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFieldId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfirmation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      mlmbox_type_confirmation_pb.Confirmation.ID.serializeBinaryToWriter
    );
  }
  f = message.getFieldId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional mlmbox.type.Confirmation.ID confirmation = 1;
 * @return {?proto.mlmbox.type.Confirmation.ID}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.prototype.getConfirmation = function() {
  return /** @type{?proto.mlmbox.type.Confirmation.ID} */ (
    jspb.Message.getWrapperField(this, mlmbox_type_confirmation_pb.Confirmation.ID, 1));
};


/**
 * @param {?proto.mlmbox.type.Confirmation.ID|undefined} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} returns this
*/
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.prototype.setConfirmation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.prototype.clearConfirmation = function() {
  return this.setConfirmation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.prototype.hasConfirmation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 field_id = 2;
 * @return {number}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.prototype.getFieldId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGenerateOneTimePasswordRequest.prototype.setFieldId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    confirmation: (f = msg.getConfirmation()) && mlmbox_type_confirmation_pb.Confirmation.ID.toObject(includeInstance, f),
    optionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    fieldsList: jspb.Message.toObjectList(msg.getFieldsList(),
    proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest;
  return proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new mlmbox_type_confirmation_pb.Confirmation.ID;
      reader.readMessage(value,mlmbox_type_confirmation_pb.Confirmation.ID.deserializeBinaryFromReader);
      msg.setConfirmation(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOptionId(value);
      break;
    case 3:
      var value = new proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field;
      reader.readMessage(value,proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.deserializeBinaryFromReader);
      msg.addFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfirmation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      mlmbox_type_confirmation_pb.Confirmation.ID.serializeBinaryToWriter
    );
  }
  f = message.getOptionId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getFieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field;
  return proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFieldId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 field_id = 1;
 * @return {number}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.prototype.getFieldId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.prototype.setFieldId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional mlmbox.type.Confirmation.ID confirmation = 1;
 * @return {?proto.mlmbox.type.Confirmation.ID}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.getConfirmation = function() {
  return /** @type{?proto.mlmbox.type.Confirmation.ID} */ (
    jspb.Message.getWrapperField(this, mlmbox_type_confirmation_pb.Confirmation.ID, 1));
};


/**
 * @param {?proto.mlmbox.type.Confirmation.ID|undefined} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} returns this
*/
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.setConfirmation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.clearConfirmation = function() {
  return this.setConfirmation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.hasConfirmation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 option_id = 2;
 * @return {number}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.getOptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.setOptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Field fields = 3;
 * @return {!Array<!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field>}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.getFieldsList = function() {
  return /** @type{!Array<!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field, 3));
};


/**
 * @param {!Array<!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field>} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} returns this
*/
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.setFieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.addFields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.Field, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationConfirmRequest.prototype.clearFieldsList = function() {
  return this.setFieldsList([]);
};


goog.object.extend(exports, proto.mlmbox.client.confirmation.v1);
